"use strict";

define('libs/filter.builder',['underscore', 'backbone'], function (_, Backbone) {
  function FilterBuilder(options) {
    this.options = _.extend({}, options);
    this.fields = [];
  }
  ;
  _.extend(FilterBuilder.prototype, Backbone.Events, {
    add: function add(name, fn) {
      if (_.isString(fn)) {
        fn = FilterBuilder.matchers[fn];
      }
      if (!_.isFunction(fn)) {
        fn = FilterBuilder.matchers["default"];
      }
      this.fields.push({
        name: name,
        match: fn
      });
      return this;
    },
    doFilter: function doFilter(collection, query) {
      var isCollection = collection instanceof Backbone.Collection;
      function iterator(item) {
        return this.doesMatchFields(item, query);
      }
      ;
      if (isCollection) {
        return new Backbone.Collection(collection.filter(iterator, this));
      }
      return _.filter(collection, iterator, this);
    },
    doesMatchFields: function doesMatchFields(item, query) {
      var matchAll = this.options.matchAll === true,
        matchMethod = matchAll ? _.all : _.any;
      if (this.fields.length === 0) {
        return false;
      }
      return matchMethod(this.fields, function (field) {
        return this.doesMatchField(field, item, query);
      }, this);
    },
    doesMatchField: function doesMatchField(field, item, query) {
      var isModel = item instanceof Backbone.Model,
        value = isModel ? item.get(field.name) : item[field.name];
      return field.match(value, query);
    }
  });
  FilterBuilder.matchers = {
    string: function string(value, query) {
      value = value == null ? '' : String(value).toLowerCase();
      query = query == null ? '' : String(query).toLowerCase();
      return value.indexOf(query) >= 0;
    }
  };
  FilterBuilder.matchers["default"] = FilterBuilder.matchers.string;
  return FilterBuilder;
});

